<div class="h-full w-full">

  <!-- ─── Header ─────────────────────────────────────────────────────────── -->
  <div class="flex items-center justify-between space-x-3 pt-7 text-sm">
    <div class="flex items-center"></div>
    <div class="flex items-center pl-16">
      <button class="custom-tabbtn text-xs focus:outline-none py-3 px-3 uppercase font-bold btn-light-orange-no">
        MEGAPAY USER ACCOUNTS
      </button>
    </div>
    <div class="flex items-center space-x-3 pr-10">
      <span 
          class="material-icons text-black text-opacity-50 cursor-pointer text-2xl"
          matTooltip="Refresh"
          matTooltipClass="custom-orange-tooltip"
          matTooltipPosition="left"
          (click)="resetTableState()">
          refresh
      </span>
      <span 
          class="material-icons text-black text-2xl cursor-pointer"
          (click)="print()"
          matTooltip="Export to Excel"
          matTooltipClass="custom-orange-tooltip"
          matTooltipPosition="left"
      >
          print
      </span>
    </div>
  </div>

  <!-- ─── Filter Form ─────────────────────────────────────────────────────── -->
  <div class="px-8 py-5">
    <form [formGroup]="form">
      <div class="w-900-px mx-auto">

        <!-- Row 1: Names & Phone -->
        <div class="grid grid-cols-12 gap-3">
          <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="">
              <span class="text-xs w-100-px font-semibold">First Name:</span>
              <input
                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                style="text-transform: capitalize;"
                formControlName="firstName"
                type="text"
                placeholder="First Name">
            </div>
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="">
              <span class="text-xs w-140-px font-semibold">Phone Number:</span>
              <input
                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                formControlName="phoneNumber"
                type="text"
                placeholder="Phone Number">
            </div>
          </div>
          <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="">
              <span class="text-xs w-100-px font-semibold">Last Name:</span>
              <input
                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                style="text-transform: capitalize;"
                formControlName="lastName"
                type="text"
                placeholder="Last Name">
            </div>
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="">
              <span class="text-xs w-160-px font-semibold">Referrer Number:</span>
              <input
                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                formControlName="referrerNumber"
                type="text"
                placeholder="Referrer Number">
            </div>
          </div>
        </div>

        <!-- Row 2: Dates, Email, Status -->
        <div class="grid grid-cols-12 gap-3">

          <div class="col-span-3">
            <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
              <app-date-input
                class="w-full text-black"
                label="Date From:"
                [parentForm]="form"
                controlName="dateFrom">
              </app-date-input>
            </div>
          </div>

          <div class="col-span-3">
            <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
              <app-date-input
                class="w-full text-black"
                label="Date To:"
                [parentForm]="form"
                controlName="dateTo">
              </app-date-input>
            </div>
          </div>

          <div class="col-span-3">
            <app-custom-dropdown-v2
              label="Status:"
              labelWidth="80px"
              [options]="statusOptions"
              [selectedText]="statusType_text || ''"
              placeholder="All"
              (selectionChange)="setStatusType($event.label, $event.value)">
            </app-custom-dropdown-v2>
          </div>

          <div class="col-span-3">
            <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
              <span class="text-xs w-100-px font-semibold">Email:</span>
              <input
                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                formControlName="email"
                type="text"
                placeholder="User Email">
            </div>
          </div>


          <!-- Row 3: Email Verified, Account Type, Tier Type -->
          <div class="col-span-4">
            <app-custom-dropdown-v2
              label="Email Verified:"
              labelWidth="90px"
              [options]="emailVerifiedOptions"
              [selectedText]="selectedVerificationOption?.label || ''"
              placeholder="== Select an option =="
              (selectionChange)="setIsVerifiedType($event)">
            </app-custom-dropdown-v2>
          </div>

          <div class="col-span-4">
            <app-custom-dropdown-v2
              label="Account Type:"
              labelWidth="120px"
              [options]="accountTypeOptions"
              [selectedText]="accountType_text || ''"
              placeholder="All"
              (selectionChange)="setAccountType($event.label, $event.value)">
            </app-custom-dropdown-v2>
          </div>

          <div class="col-span-4">
            <app-custom-dropdown-v2
              label="Tier Type:"
              labelWidth="90px"
              [options]="tierTypeOptions"
              [selectedText]="tierType_text || ''"
              placeholder="All"
              (selectionChange)="setTierType($event.label, $event.value)">
            </app-custom-dropdown-v2>
          </div>

        </div>

        <!-- Submit -->
        <div class="w-full flex items-center justify-center mt-5 mb-2">
          <button
            (click)="submit()"
            class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
            Submit
          </button>
        </div>

      </div>
    </form>
  </div>

  <!-- ─── Table Controls ──────────────────────────────────────────────────── -->
  <app-table-controls
    [currentLimit]="size"
    [searchPlaceholder]="'Search'"
    (limitChangeEvent)="onLimitChangeFromComponent($event)"
    (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
    (keydownEvent)="keyDownFunction($event)">
  </app-table-controls>

  <!-- ─── Data Table ──────────────────────────────────────────────────────── -->
  <app-data-table
    [tableSubHeader]="tableSubHeader"
    [isLoading]="isLoading"
    [sort_type]="sort_type"
    (toggleOnSort)="sortList($event.key, $event.type)"
    [stickyLastColumn]="true">

    <tr class="focus:outline-none" *ngFor="let item of account_lists">
      <td class="text-center">{{ item.firstName    | nullWithDefault | titlecase }}</td>
      <td class="text-center">{{ item.middleName   | nullWithDefault | titlecase }}</td>
      <td class="text-center">{{ item.lastName     | nullWithDefault | titlecase }}</td>
      <td class="text-center">{{ item.phoneNumber  | nullWithDefault }}</td>
      <td class="text-center">{{ item.email        | nullWithDefault }}</td>
      <td class="text-center">{{ item.dateCreated  | asiaDate | nullWithDefault }}</td>
      <td class="text-center">{{ item.referrerName | nullWithDefault | titlecase }}</td>
      <td class="text-center">{{ item.referralSource | nullWithDefault | titlecase }}</td>
      <td class="text-center">
        <span *ngIf="item.balance !== null && item.balance !== 0">{{ item.balance | number:'1.2-2' }}</span>
        <span *ngIf="item.balance === null || item.balance === 0">0</span>
      </td>
      <td class="text-center">
        <span *ngIf="item.rewards !== null && item.rewards !== 0">{{ item.rewards }}</span>
        <span *ngIf="item.rewards === null || item.rewards === 0">0</span>
      </td>
      <td class="text-center">{{ item.status      | nullWithDefault }}</td>
      <td class="text-center">{{ item.accountType | nullWithDefault }}</td>
      <td class="text-center">{{ item.tierType    | nullWithDefault }}</td>
      <td class="text-center">{{ getIsEmailVerifiedLabel(item.isEmailVerified) | nullWithDefault }}</td>
      <td class="text-center">{{ item.directVerifiedEmailBy | nullWithDefault }}</td>
      <td class="text-center">{{ item.directVerifiedEmailDate | asiaDate | nullWithDefault }}</td>
      <td class="text-center">
        <div class="flex items-center justify-center gap-1">
          <ng-container *ngIf="getAdminButtonState() as btnState">

            <!-- Disable -->
            <span class="action-wrapper"
              [class.is-disabled]="btnState.disabled || item.status === 'Disabled'"
              [matTooltip]="btnState.disabled ? btnState.tooltip : (item.status === 'Disabled' ? 'Account is already disabled' : 'Disable account')"
              matTooltipClass="custom-orange-tooltip">
              <span class="action red" [class.disabled]="btnState.disabled || item.status === 'Disabled'" (click)="disable(item.uid)"></span>
            </span>

            <!-- Enable -->
            <span class="action-wrapper"
              [class.is-disabled]="btnState.disabled || item.status === 'Active'"
              [matTooltip]="btnState.disabled ? btnState.tooltip : (item.status === 'Active' ? 'Account is already enabled' : 'Enable account')"
              matTooltipClass="custom-orange-tooltip">
              <span class="action green" [class.disabled]="btnState.disabled || item.status === 'Active'" (click)="enable(item.uid)"></span>
            </span>

            <!-- View -->
            <span class="action-wrapper"
              matTooltip="View account"
              matTooltipClass="custom-orange-tooltip">
              <span class="action black" (click)="navigateToView(item.uid)"></span>
            </span>

            <!-- Direct Email Verify -->
            <span class="action-wrapper"
              [class.is-disabled]="btnState.disabled || item.isEmailVerified"
              [matTooltip]="btnState.disabled ? btnState.tooltip : (item.isEmailVerified ? 'Account email is already verified' : 'Direct Email Verify')"
              matTooltipClass="custom-orange-tooltip">
              <span class="action blue" [class.disabled]="btnState.disabled || item.isEmailVerified" (click)="directVerifyEmail(item.uid)"></span>
            </span>

          </ng-container>
        </div>
      </td>
    </tr>

  </app-data-table>

  <!-- ─── Empty State ─────────────────────────────────────────────────────── -->
  <div
    *ngIf="!isLoading && (!account_lists || account_lists.length === 0)"
    class="bg-light-orange w-full py-3 text-gray-500"
    style="text-align: center; border-bottom: 1px solid rgba(0,0,0,0.2);">
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;">
      <span class="font-semibold text-xs uppercase tracking-wide">No records found</span>
      <span class="italic text-xs">Try adjusting your search or filter criteria.</span>
    </div>
  </div>

  <!-- ─── Pagination ──────────────────────────────────────────────────────── -->
  <app-pagination
    [currentPage]="current_page"
    [totalPages]="total_pages"
    [pageSize]="size"
    [totalItems]="total"
    (pageChange)="setPage($event)"
    (previousPage)="prevPage()"
    (nextPage)="nextPage()"
    showTotalEntries="true">
  </app-pagination>

</div>

<ngx-spinner type="border" size="medium">
  <app-megapay-loader></app-megapay-loader>
</ngx-spinner>